/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type saveAccessPinMutationVariables = {
  pin: string;
};
export type saveAccessPinMutationResponse = {
  readonly invsysSaveAccessPin: {
    readonly success: boolean;
  };
};
export type saveAccessPinMutation = {
  readonly response: saveAccessPinMutationResponse;
  readonly variables: saveAccessPinMutationVariables;
};

/*
mutation saveAccessPinMutation(
  $pin: String!
) {
  invsysSaveAccessPin(pin: $pin) {
    success
  }
}
*/

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'pin',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'pin',
            variableName: 'pin',
          },
        ],
        concreteType: 'InvsysSaveAccessPinResponse',
        kind: 'LinkedField',
        name: 'invsysSaveAccessPin',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'success',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'saveAccessPinMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'saveAccessPinMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '20563b5d6d82dbcd7441ef63829e60e3',
      id: null,
      metadata: {},
      name: 'saveAccessPinMutation',
      operationKind: 'mutation',
      text: 'mutation saveAccessPinMutation(\n  $pin: String!\n) {\n  invsysSaveAccessPin(pin: $pin) {\n    success\n  }\n}\n',
    },
  };
})();
(node as any).hash = 'a2d36af9dede1a2a63ced8632c1ddec2';
export default node;
